import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Calendar, Lightbulb, User } from 'lucide-react';

interface CreateMealPlanClientScheduleSectionProps {
  clientLabel?: string;
  clientField: React.ReactNode;
  startDateField: React.ReactNode;
  endDateField: React.ReactNode;
  tipContent?: React.ReactNode;
  showTipIcon?: boolean;
}

const CreateMealPlanClientScheduleSection: React.FC<CreateMealPlanClientScheduleSectionProps> = ({
  clientLabel = 'Client Name',
  clientField,
  startDateField,
  endDateField,
  tipContent,
  showTipIcon = true,
}) => {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <User className="h-5 w-5" />
            Client Selection
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div>
            <Label>{clientLabel}</Label>
            {clientField}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5" />
            Plan Date Range
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {tipContent && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex items-start gap-2">
                {showTipIcon && (
                  <Lightbulb className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                )}
                <div>{tipContent}</div>
              </div>
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {startDateField}
            {endDateField}
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default CreateMealPlanClientScheduleSection;

